import { Player } from "../model/Player";

export const convertPickup: (data: any[]) => Player[] = (data: any) => {
    const result = [...data];
    result.shift();
    return result.map(e => {
        return {
            name: e[0],
            team: e[1],
            pos: e[2],
            status: e[3],
            highlight: e[4] === "TRUE",
            notes: e[5],
            availability: 'Maybe available', //TODO: remove in later version
        } as Player;
    }).filter(e => e.name)
}